export default function MapRouteConfig($stateProvider) {
  'ngInject';

  $stateProvider
    .state('map', {
      url: '/map',
      template: '<map-main></map-main>',
      redirectTo: 'map.equipment',
      requiredDatapoints: ['gps'],
      requiredFeatures: ['map']
    })
    .state('map.equipment', {
      url: '/assets',
      template: '<map-equipment></map-equipment>',
      requiredDatapoints: ['gps'],
      requiredFeatures: ['map']
    })
    .state('map.equipment.detail', {
      url: '/{equipmentId}',
      template: '<map-equipment-detail panel-off-screen="panelOffscreen"></map-equipment-detail>',
      requiredDatapoints: ['gps'],
      requiredFeatures: ['map']
    });
}